import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createOrdersApi, orderKeys } from '../api';
import type { OrderHistoryResult } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseOrderHistoryOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrderHistory(id: string, options: UseOrderHistoryOptions = {}): UseQueryResult<OrderHistoryResult> {
  const { enabled = true } = options;
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);

  return useQuery({
    enabled: enabled && id.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getOrderHistory(id),
    queryKey: orderKeys.history(id),
    staleTime: LIST_STALE_TIME_MS,
  });
}
